import { ReactNode } from "react";
import { SystemProps } from "@storyofams/react-ui";
import styled from "styled-components";

import { Text } from "../../Text";

interface BadgeProps extends SystemProps {
  children: ReactNode;
}

const Wrapper = styled(Text)`
  font-weight: bold;
  font-size: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  @media (max-width: 768px) {
    width: 12px;
    height: 12px;
    font-size: 8px;
  }
`;

export const Badge = ({ children, ...props }: BadgeProps) => (
  <Wrapper backgroundColor="oldPink" color="grey800" {...props}>
    {children}
  </Wrapper>
);
